import React from 'react';
import { Modal } from 'react-bootstrap';
import cn from 'classnames';

const initialState = {
  isShow: false,
  zoomImg: null,
};

export const Document = ({ data, onClose }) => {
  const [{ isShow, zoomImg }, setState] =
    React.useState(initialState);

  const $handleClose = async() => {
    setState((prevState) => ({ ...prevState, isShow: false, zoomImg: null }));
  }

  return (
    <>
      <Modal.Body>
        <div
          className={cn(
            'd-flex flex-wrap pt-2',
            'gap-2 align-items-center justify-content-center'
          )}
        >
          {data?.images?.map((d, i) => (
            <div key={i}>
              <img
                className="img-hover rounded-3"
                src={d}
                alt=""
                onClick={() => {
                  setState((prevState) => ({
                    ...prevState,
                    isShow: true,
                    zoomImg: d,
                  }));
                }}
              />
            </div>
          ))}
        </div>
      </Modal.Body>

      <Modal
        show={isShow}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="xl"
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={$handleClose}
          />
          <div className="text-center mt-4" style={{ maxHeight: 500 }}>
            <img
              src={zoomImg?.replace('_thumb', '')}
              alt=""
              className="img-fluid"
              style={{ maxHeight: 500 }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}